import React, { Component } from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import * as config from './common/config.js';
import { getRoutes } from './common/routing/routes.js';
import { actionCreators as localisationActions } from './common/localisation/store.js';

class AppContainer extends Component {
  componentDidMount() {
    //load initial data for the app
    this.props.loadLocalisationConfigs();
  }

  render() {
    const routes = getRoutes();
    return (
      <BrowserRouter basename={config.basePath}>
        <div>
          <Switch>{routes}</Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default connect(null, {
  loadLocalisationConfigs: localisationActions.loadLocalisationConfigs,
})(AppContainer);
